import { render, staticRenderFns } from "./SalesOrderSelect.vue?vue&type=template&id=5da1456b&"
import script from "./SalesOrderSelect.vue?vue&type=script&lang=js&"
export * from "./SalesOrderSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports